import FailedIllustration from 'assets/svg/failed/failed-illustration.svg'
import ConfirmationModal from 'common/components/ConfirmationModal'
import Typography from 'common/components/Typography'
import theme from 'common/theme'
import styled from 'styled-components'

const StyledLink = styled.a`
  color: ${theme.colors.redOrange};
`

const ConfirmationModalDescription = (): JSX.Element => {
  return (
    <Typography type="rparagraph" textAlign="center">
      {`Jika Anda keluar sekarang, data Anda akan `}
      <strong>dihapus</strong>
      {` dan status
      profil Anda akan tetap tercatat sebagai `}
      <strong>Individu.</strong>
      {` Untuk mengisi informasi bisnis,
      silakan kunjungi halaman `}
      <StyledLink href="/customer/profile">
        Profil Data Diri.
      </StyledLink>
    </Typography>
  )
}

interface IModalConfirmationCloseProfiling {
  showConfirmationCloseProfileType: boolean
  toggleQuestionnaireModal: Function
  handleCloseConfirmationModal: Function
}

function ModalConfirmationCloseProfiling({
  showConfirmationCloseProfileType,
  toggleQuestionnaireModal,
  handleCloseConfirmationModal,
}: IModalConfirmationCloseProfiling): JSX.Element {
  return (
    <ConfirmationModal
      isOpen={showConfirmationCloseProfileType}
      description={<ConfirmationModalDescription />}
      icon={<FailedIllustration />}
      title="Yakin Keluar?"
      primaryButtonText="Lanjutkan"
      secondaryButtonText="Keluar"
      onClickPrimary={toggleQuestionnaireModal}
      onClickSecondary={handleCloseConfirmationModal}
    />
  )
}

export default ModalConfirmationCloseProfiling
